<template>
  <div class="p-3">
    <b-form>
      <div class="premium-card shadow-sm mb-4">
        <div class="card-header-premium">
          <i class="fa fa-globe mr-2"></i> DADOS DE EXPORTAÇÃO / DIVERSOS
        </div>
        <div class="p-3">
          <b-form-row>
            <b-col md="4">
              <b-form-group label="UF Embarque" label-for="ufEmbarque" class="premium-form-group">
                <b-form-select id="ufEmbarque" v-model="local.ufEmbarque" :options="ufOptions" class="rounded-pill" :disabled="!podeEditar" />
              </b-form-group>
            </b-col>

            <b-col md="8">
              <b-form-group label="Local de Embarque" label-for="localEmbarque" class="premium-form-group">
                <b-form-input id="localEmbarque" v-model="local.localEmbarque" class="rounded-pill" :disabled="!podeEditar" />
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col md="12">
              <b-form-group label="Local de Despacho" label-for="localDespacho" class="premium-form-group mb-0">
                <b-form-input id="localDespacho" v-model="local.localDespacho" class="rounded-pill" :disabled="!podeEditar" />
              </b-form-group>
            </b-col>
          </b-form-row>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
export default {
  name: 'NfeTranspDiversos',
  props: { 
    value: { type: Object, default: () => ({}) },
    podeEditar: { type: Boolean, default: false }
  },
  data() {
    return {
      local: Object.assign({}, this.value || {}),
      ufOptions: [
        // TODO: replace with real UF list from store/dataset
        { value: '', text: '(selecione)' },
        { value: 'SP', text: 'SP' },
        { value: 'RJ', text: 'RJ' },
        { value: 'MG', text: 'MG' }
      ]
    }
  },
  watch: {
    value: { handler(v) { this.local = Object.assign({}, v || {}) }, deep: true },
    local: { handler() { this.$emit('input', Object.assign({}, this.local)); this.$emit('changed') }, deep: true }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/faturamento/nfe/partials/NfeTranspDiversos.vue